import { DatePicker, Select } from "antd";
import { cloneDeep, set } from "lodash";
import moment from "moment";
import "./style.scss";
import React, { FC, HTMLAttributes, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getAccountingSummary,
  getCreditSummary,
  getFranciseReport,
  getPaymentSummary,
  getPaymentUserSummary,
} from "../../../redux/slices";
import { Menu, MenuItem } from "@mui/material";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";
import {
  ACCOUNT_SUMMARY,
  CTA_SIZE,
  CTA_TYPE,
  DATE_TIME_FORMATS,
  GROUP_BY_TYPES,
} from "../../../data/constants";
import { RootState } from "../../../redux/store";
import { convertArrayToObject } from "../../../helpers/catalog-helper";
import {
  getOptionForDates,
  isFeatureAllowed,
  isSourcePos,
} from "../../../helpers/common-helper";
import { fetchCommonData, getAllUsers } from "../../../redux/slices";
import { isMobileTabDevice } from "../../../helpers/device-info-helper";
import BranchFilterComponent from "../../../components/reusable-ui/branch-filter";
import ZeroScreen from "./zero-screen";
import PaymentSummary from "./payment-summary";
import CreditSummary from "./credit-summary";
import SalesSummary from "./sales-summary";
import DatePickerWrapper from "../../../components/reusable-ui/date-picker-wrapper";
import CtaComponent from "../../../components/reusable-ui/cta";
import { COMPONENT_MAP } from "./constant";
import { FranchiseReport } from "./franchise-report";

interface DeviceType {
  branchName: string;
  deviceId: string;
  label: string;
  lastLoginTime: string;
  lastUserName: any;
  serialNumber: number;
  status: string;
}

interface DeviceFilterPayload {
  branchIds: string[];
  pageSize: number;
  lastKey?: any;
}

interface SearchFilterType {
  balanceDue?: boolean;
  status: string;
  pageSize: number;
  branchId?: string;
  date?: string;
  buid?: string;
  deviceId?: any;
  deviceLabel?: string;
  lastKey?: any;
  groupBy: any;
}

interface DeviceDataMap {
  [key: string]: DeviceType;
}

type KeyType = "groupBy" | "text";

type groupByMap = {
  brand: { [key in KeyType]: string };
  branch: { [key in KeyType]: string };
};

let index: KeyType = "groupBy",
  mode: KeyType = "text",
  PLACEHOLDER = "Group By";
let map: groupByMap = {
  brand: { [index]: "brand", [mode]: "Brand" },
  branch: { [index]: "branch", [mode]: "Branch" },
};

const AccountSummary: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const [settlements, setSettlements] = useState([]);
  const [hideFilterMobile, setHideFilterMobile] = useState<any>({});
  const userData = useSelector((state: any) => state.businessReducer.userData);
  const [ctaDisabled, setCtaDisabled] = useState<boolean>(true);
  const allowedBusinessBranchesDataMap = convertArrayToObject(
    userData.permittedBranches,
    "branchId"
  );
  const [isBranchUpdated, setIsBranchUpdated] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const firstAllowedFeature: any = useMemo(
    () =>
      Object.values(ACCOUNT_SUMMARY).find((summaryType: any) =>
        isFeatureAllowed(summaryType.feature)
      ),
    []
  );
  const [summaryDropdown, setSummaryDropdown] = useState(
    firstAllowedFeature.id
  );
  const [groupBy, setGroupBy] = useState<string>(GROUP_BY_TYPES.branch);
  const [payType, setPayType] = useState<string>('');
  const [invoiceType, setInvoiceType] = useState<string>('')
  const [franchiseData, setFranchiseData] = useState<any[]>([]);
  const [franchiseLastKey, setFranchiseLastKey] = useState({});
  const [showFilterResults, setShowFilterResults] = useState<Boolean>(true);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const currentBusinessId = useSelector(
    (state: any) => state.businessReducer?.businessData?.branchId
  );
  const { permittedBranchesData } = useSelector((state: RootState) => ({
    permittedBranchesData: state.businessReducer.userData.permittedBranches,
  }));
  const { inceptionDate } = useSelector((state: RootState) => ({
    inceptionDate: state.businessReducer.businessData.activationDate,
  }));
  const startDate: Date = new Date(inceptionDate);
  const daysDifference: number = Math.floor(
    (new Date().getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  const optionForDates = getOptionForDates(daysDifference);
  const { allBrandsData } = useSelector((state: RootState) => ({
    allBrandsData: convertArrayToObject(
      state.businessReducer.allBrandsData,
      "mid"
    ),
  }));
  let [DeviceDataMap, setDeviceDataMap] = useState({} as DeviceDataMap);

  let intialSearchState: SearchFilterType = {
    balanceDue: false,
    status: "Open",
    pageSize: 10,
    branchId: getDefaultBranchId(),
    date: moment(new Date()).format(DATE_TIME_FORMATS.yearMonthDay),
    buid: "",
    deviceId: "",
    deviceLabel: "",
    lastKey: {},
    groupBy: "",
  };

  const [state, setState] = useState({
    settlementId: "",
    viewSettlement: false,
    searchFilters: intialSearchState,
    devicePagination: {},
  });
  const [filterConfig, setFilterConfig] = useState<any>({
    periods: [],
    branches: getDefaultBranchId(),
    bizzBrandNames: Object.keys(allBrandsData),
    groupBy: Object.keys(map)[1],
    dateRange: {
      startDate: moment(new Date()).subtract(7, "d"),
      endDate: moment(new Date()),
    },
  });

  const DROPDOWN_CONFIG = {
    group_by: {
      onSubmit: (data: any) => handleFilterChange(data[0], "groupBy"),
      optionsMap: map,
      customFormClasses: { root: "h-[40px]" },
      placeholder: PLACEHOLDER,
      preSelectedValues: filterConfig.groupBy,
      uniqueKey: "groupBy",
      getListItemText: (data: any) => data[mode],
      parentClass:
        "smd:ml-[0%] rounded-[8px] !h-[40px] flex justify-center cursor-pointer items-center smd:w-full w-[100px] !mt-0 flex ",
    },
    brand_name: {
      onSubmit: (data: any) => handleFilterChange(data, "bizzBrandNames"),
      optionsMap: allBrandsData,
      customFormClasses: { root: "h-[40px]" },
      placeholder: "Select Brand",
      preSelectedValues: filterConfig.bizzBrandNames,
      uniqueKey: "mid",
      getListItemText: (data: any) => data?.brandName || "",
      isMultiSelect: true,
      dropdownHeading: "Brand Name",
      parentClass:
        "smd:ml-[0%] rounded-[8px] !h-[40px] flex justify-center cursor-pointer items-center w-[150px] tb:w-[48%] sm:w-[98%] !mt-0 flex ",
    },
  };

  useEffect(() => {
    dispatch(getAllUsers());
    getSummaryToShow();
  }, [summaryDropdown]);

  useEffect(() => {
    setDeviceDataMap({});
  }, [state.searchFilters.groupBy]);

  useEffect(() => {
    filterSummary()
  }, [payType, invoiceType])

  const handleDateRange = (data: any, currentValue?: string[]) => {
    const { startDate, endDate } = data;
    handleFilterChange(
      { startDate: moment(startDate), endDate: moment(endDate) },
      "dateRange"
    );
  };

  const handleFilterChange = (value: any, fieldToUpdate: string, enableCta: boolean = true) => {
    let dataToUpdate = cloneDeep(filterConfig);
    set(dataToUpdate, fieldToUpdate, value);
    setFilterConfig(dataToUpdate);
    if (isBranchUpdated && enableCta) {
      setCtaDisabled(false);
    }
    if (Object.keys(dataToUpdate).indexOf(fieldToUpdate) > -1) {
      setIsBranchUpdated(true);
    }
  };

  const handleHideFilter = (hideFilterData: any) => {
    setHideFilterMobile(hideFilterData);
  };

  function disabledDate(current: any) {
    return (
      current &&
      (current > moment().endOf("day") ||
        current < moment().subtract(30, "days").startOf("day"))
    );
  }

  function handleFranchiseData(
    response: { results: any[]; lastKey: any },
    operation: string
  ) {
    if (operation?.length) {
      setFranchiseData((prev) => [...prev, ...response?.results]);
    } else {
      setFranchiseData(response?.results);
    }
    setFranchiseLastKey(response?.lastKey);
  }

  function getPayload() {
    if (summaryDropdown === ACCOUNT_SUMMARY.credit.id) {
      let periods = null
      if (filterConfig.dateRange.startDate && filterConfig.dateRange.endDate) {
        periods = [{
          startDate: moment(filterConfig.dateRange.startDate).format(
            DATE_TIME_FORMATS.yearMonthDay
          ),
          endDate: moment(filterConfig.dateRange.endDate).format(
            DATE_TIME_FORMATS.yearMonthDay
          ),
        }]
      }
      return {
        branchIds: filterConfig.branches
          ? filterConfig.branches
          : state.searchFilters.branchId,
        periods,
        bizzBrandNames: filterConfig.bizzBrandNames.map(
          (mid: string) => allBrandsData[mid].brandName
        ),
        groupBy: filterConfig.groupBy,
        isNew: true,
      };
    } else if (summaryDropdown === ACCOUNT_SUMMARY.royalty.id) {
      return {
        dataToSend: {
          branchIds: filterConfig.branches,
          endDay: filterConfig?.dateRange?.endDate ? moment(filterConfig?.dateRange?.endDate).format(
            DATE_TIME_FORMATS.yearMonthDay
          ) : "",
          startDay: filterConfig?.dateRange?.startDate? moment(filterConfig?.dateRange?.startDate).format(
            DATE_TIME_FORMATS.yearMonthDay
          ): "",
          pageSize: 20,
          invoiceType: invoiceType?.length ? invoiceType : null,
          payStatus: payType?.length ? payType : null,
        },
        callback: handleFranchiseData,
      };
    } else {
      return {
        branchIds: filterConfig.branches
          ? filterConfig.branches
          : state.searchFilters.branchId,
        periods: [
          state.searchFilters.date ? moment(state.searchFilters.date).format(
            DATE_TIME_FORMATS.yearMonthDay
          ) : moment(new Date()).format(DATE_TIME_FORMATS.yearMonthDay),
        ],
        bizzBrandNames: filterConfig.bizzBrandNames.map(
          (mid: string) => allBrandsData[mid].brandName
        ),
        groupBy: filterConfig.groupBy,
        isNew: true,
      };
    }
  }

  function filterSummary() {
    let dataToPost = getPayload();
    setShowFilterResults(true);
    if (summaryDropdown === ACCOUNT_SUMMARY.payment.id) {
      dispatch(getPaymentSummary(dataToPost));
      dispatch(getPaymentUserSummary(dataToPost));
    } else if (summaryDropdown === ACCOUNT_SUMMARY.credit.id) {
      dispatch(getCreditSummary(dataToPost));
    } else if (summaryDropdown === ACCOUNT_SUMMARY.sales.id) {
      dispatch(getAccountingSummary(dataToPost));
    } else if (summaryDropdown === ACCOUNT_SUMMARY.royalty.id) {
      dispatch(getFranciseReport(dataToPost));
    }
    setCtaDisabled(true);
    setGroupBy(dataToPost?.groupBy);
  }

  function handleCallApi() {
    let payload: any = getPayload();
    if (Object.keys(franchiseLastKey || {})?.length && payload?.dataToSend) {
      payload.dataToSend["lastKey"] = franchiseLastKey;
      payload.callback = (response: any) =>
        handleFranchiseData(response, "add");
      dispatch(getFranciseReport(payload));
    }
  }

  //To get the summary data as per dropdown value
  function getSummaryToShow() {
    let dataToPost = getPayload();
    if (summaryDropdown === ACCOUNT_SUMMARY.payment.id)
      dispatch(getPaymentSummary(dataToPost));
    else if (summaryDropdown === ACCOUNT_SUMMARY.credit.id)
      dispatch(getCreditSummary(dataToPost));
    else if (summaryDropdown === ACCOUNT_SUMMARY.sales.id)
      dispatch(getAccountingSummary(dataToPost));
  }

  function getDefaultBranchId() {
    if (isSourcePos()) return currentBusinessId;
    return allowedBusinessBranchesDataMap &&
      Object.keys(allowedBusinessBranchesDataMap)?.length > 0
      ? Object.keys(allowedBusinessBranchesDataMap)
      : "";
  }

  function handleDevices(res: any) {
    setState((prevState: any) => ({
      ...prevState,
      devicePagination: res.lastKey || {},
    }));
    let newDataMap = cloneDeep(convertArrayToObject(res?.results, "deviceId"));
    setDeviceDataMap(
      res.results?.length ? Object.assign(newDataMap, DeviceDataMap) : {}
    );
  }

  function renderCustomDropDown(dropdownConfig: any) {
    return (
      <CustomDropdown
        {...dropdownConfig}
        dropdownSelectClass={
          "!h-[40px] ml-[0px] p-0 dropdownSelectClass rounded-[8px]"
        }
        labelClassName={"flex"}
      />
    );
  }

  const onDateRangeSubmission = (data: any) => {
    let enableCta = true;
    // if (!data) {
    //   enableCta = false;
    //   setCtaDisabled(true);
    // }
    handleFilter(
      data ? moment(data).format(DATE_TIME_FORMATS.yearMonthDay) : "",
      "date"
    );
    handleFilterChange(data, "periods", enableCta);
  };

  function handleFilter(value: string, name: string) {
    let filter = {} as SearchFilterType;
    filter = { ...state.searchFilters, [name]: value };
    setState({ ...state, searchFilters: filter });
  }

  function validateComponent(componentName: string) {
    const selectedValue = summaryDropdown;
    switch (componentName) {
      case COMPONENT_MAP.DATE_RANGE_PICKER:
        return (
          selectedValue === ACCOUNT_SUMMARY.credit.id ||
          selectedValue === ACCOUNT_SUMMARY.royalty.id
        );
      case COMPONENT_MAP.DATE_PICKER:
        return !(
          selectedValue === ACCOUNT_SUMMARY.credit.id ||
          selectedValue === ACCOUNT_SUMMARY.royalty.id
        );
      case COMPONENT_MAP.BRAND_NAME:
        return selectedValue != ACCOUNT_SUMMARY.royalty.id;
      case COMPONENT_MAP.GROUP_BY:
        return selectedValue != ACCOUNT_SUMMARY.royalty.id;
      default:
        return true;
    }
  }

  function renderHeader() {
    return (
      <div
        className={` smd:my-12 flex items-center gap-y-6 w-[100%] px-[20px] sm:gap-y-[20px] flex-wrap smd:px-16 gap-x-[12px] tb:gap-x-12 py-12 tb:gap-y-16 ${
          summaryDropdown === ACCOUNT_SUMMARY.credit.id ? "pl-12 " : ""
        }  w-full tb:py-12 smd:pb-0 bg-white`}
      >
        {validateComponent(COMPONENT_MAP.DATE_RANGE_PICKER) && (
          <DatePickerWrapper
            options={optionForDates}
            drpdownUniqueKey={"value"}
            placeholder="please select your date range"
            preSelectedDropdownValue={optionForDates[0].value}
            getDateRange={handleDateRange}
            customStyle="h-40 sm:!w-[98%] w-[220px] rounded-tl-[8px] rounded-bl-[8px] smd:mt-0 custom-date-range-picker cursor-pointer"
          />
        )}
        {validateComponent(COMPONENT_MAP.DATE_PICKER) && (
          <DatePicker
            className={`custom-date-picker h-40 w-[15%] cursor-pointer smd:!ml-0 smd:mt-0 smd:items-center tb:w-[48%] sm:w-[98%] rounded-[8px]
            hover:border-black
            focus:border-black
            border-[#C4C4C4]
          `}
            format={DATE_TIME_FORMATS.dayMonthYear}
            value={
              state.searchFilters.date
                ? moment(state.searchFilters.date)
                : moment(new Date())
            }
            disabledDate={disabledDate}
            onChange={onDateRangeSubmission}
          />
        )}
        {validateComponent(COMPONENT_MAP.BRANCH_FILTER) && (
          <BranchFilterComponent
            branchDataList={permittedBranchesData}
            onApplyCtaClick={(branches: any) =>
              handleFilterChange(branches, "branches")
            }
            selectAllBranches={true}
            parentClass={`custom-branch-filter !h-[40px] ml-[0px] w-[180px] hover:border-black border-[#D8D8D8] !rounded-[8px] tb:w-[48%] sm:!w-[98%] smd:ml-0 sm:!mt-0
       
        `}
            customClass={
              "!h-[40px] smd:text-[14px] !rounded-[8px] !border-[#bdbdbd]"
            }
          ></BranchFilterComponent>
        )}
        {validateComponent(COMPONENT_MAP.BRAND_NAME) &&
          renderCustomDropDown(DROPDOWN_CONFIG.brand_name)}
        {validateComponent(COMPONENT_MAP.GROUP_BY) && (
          <div className="flex items-center  tb:w-[48%] sm:w-[98%] smd:!ml-0">
            <span className=" whitespace-nowrap mr-5 opacity-70">
              {"Group:"}
            </span>
            {renderCustomDropDown(DROPDOWN_CONFIG.group_by)}
          </div>
        )}
        <CtaComponent
          ctaSize={CTA_SIZE.small}
          ctaType={CTA_TYPE.active_cta}
          onCtaClick={filterSummary}
          customClass={`ml-12 smd:w-[98%] !h-[40px] smd:ml-0`}
          ctaText={"Apply"}
          isDisabled={ctaDisabled}
        />
      </div>
    );
  }

  function renderFilters() {
    return (
      <div className="flex smd:flex-col filter-container">
        {((isMobileTabDevice() &&
          Object.entries(hideFilterMobile).length === 0) ||
          !isMobileTabDevice()) && (
          <>
            <div
              className="flex justify-center w-[250px] items-center px-6  text-[#496A93] bg-[#E4EAF5] smd:w-[100%] smd:justify-between smd:text-[14px] py-16 smd:px-16 gap-8 whitespace-nowrap mr-2 font-semibold"
              onClick={handleClick}
            >
              <span>{ACCOUNT_SUMMARY[summaryDropdown].label}</span>
              <span className="rista-sprite ic-dropdown"></span>
            </div>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              className="border-black"
            >
              {Object.values(ACCOUNT_SUMMARY).map(
                (summaryType: any, index: any) => {
                  if (
                    isFeatureAllowed(summaryType.feature) ||
                    summaryType.id === ACCOUNT_SUMMARY.royalty.id
                  ) {
                    return (
                      <MenuItem
                        onClick={handleClose}
                        className="hover:bg-[#397ef51a]"
                        key={index}
                      >
                        <p
                          className="text-[14px] hover:text-[#397EF5] hover:font-semibold"
                          onClick={() => setSummaryDropdown(summaryType.id)}
                        >
                          {summaryType.label}
                        </p>
                      </MenuItem>
                    );
                  }
                }
              )}
            </Menu>
          </>
        )}
        {((isMobileTabDevice() &&
          Object.entries(hideFilterMobile).length === 0) ||
          !isMobileTabDevice()) && (
          <>
            {showFilterResults && isMobileTabDevice() ? (
              <div className="flex bg-white justify-between w-[100%] smd:overflow-hidden border-b-[1px] p-16">
                <div className="flex-col">
                  {summaryDropdown != ACCOUNT_SUMMARY.royalty.id && (
                    <p className="font-semibold">
                      {state.searchFilters.date
                        ? moment(state.searchFilters.date).format(
                            DATE_TIME_FORMATS.yearMonthDay
                          )
                        : moment(new Date()).format(
                            DATE_TIME_FORMATS.yearMonthDay
                          )}
                    </p>
                  )}
                  {summaryDropdown === ACCOUNT_SUMMARY.royalty.id && (
                    <div className="flex items-center gap-[5px]">
                    <p className="font-semibold">
                      {moment(filterConfig?.dateRange?.startDate).format(
                        DATE_TIME_FORMATS.yearMonthDay
                      ) + ' - '}
                    </p>
                    <p className="font-semibold">
                    {moment(filterConfig?.dateRange?.endDate).format(
                          DATE_TIME_FORMATS.yearMonthDay
                        )}
                    </p>
                    </div>
                  )}
                  <div className="opacity-50 text-[13px] flex">
                    <div>
                      <span className="mr-2">
                        {filterConfig.branches
                          ? filterConfig.branches.length
                          : permittedBranchesData.length}
                      </span>
                      <span className="pr-6 border-r-2">Branches</span>
                    </div>
                    {summaryDropdown != ACCOUNT_SUMMARY.royalty.id && (
                      <div>
                        <span className="mx-2">
                          {filterConfig.bizzBrandNames.length}
                        </span>
                        <span className="pr-6 border-r-2">Brands</span>
                      </div>
                    )}
                    {summaryDropdown != ACCOUNT_SUMMARY.royalty.id && (
                      <div>
                        <span className="mx-2">Group:</span>
                        <span className="">
                          {map?.[groupBy as keyof groupByMap]?.[mode]}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex justify-end float-right flex-row-reverse">
                  <p
                    className="text-[#397EF5] text-[14px] font-semibold"
                    onClick={() => {
                      setShowFilterResults(false);
                    }}
                  >
                    Modify
                  </p>
                </div>
              </div>
            ) : (
              renderHeader()
            )}
          </>
        )}
      </div>
    );
  }

  function noFiltersApplied() {
    let { searchFilters } = state;
    return (
      searchFilters.buid === "" &&
      searchFilters.date === "" &&
      searchFilters.deviceId === "" &&
      searchFilters.status === "Open" &&
      searchFilters.branchId === ""
    );
  }

  function renderSelectedSummaryType() {
    switch (summaryDropdown) {
      case ACCOUNT_SUMMARY.payment.id:
        return (
          <PaymentSummary
            selectedDate={state.searchFilters.date!}
            branchIds={
              filterConfig.branches
                ? filterConfig.branches
                : permittedBranchesData
            }
            brandName={filterConfig.bizzBrandNames.map(
              (mid: string) => allBrandsData[mid]?.brandName
            )}
            groupBy={groupBy}
            hideFilterMobile={handleHideFilter}
            showFilterResults={showFilterResults}
          />
        );

      case ACCOUNT_SUMMARY.credit.id:
        return (
          <CreditSummary
            branchIds={
              filterConfig.branches
                ? filterConfig.branches
                : permittedBranchesData
            }
            selectedDate={moment(filterConfig.dateRange.startDate).format(
              DATE_TIME_FORMATS.yearMonthDay
            )}
            brandName={filterConfig.bizzBrandNames.map(
              (mid: string) => allBrandsData[mid]?.brandName
            )}
            groupBy={groupBy}
            hideFilterMobile={handleHideFilter}
            showFilterResults={showFilterResults}
          />
        );

      case ACCOUNT_SUMMARY.sales.id:
        return (
          <SalesSummary
            hideFilterMobile={handleHideFilter}
            showFilterResults={showFilterResults}
            periods={[
              moment(state.searchFilters.date).format(
                DATE_TIME_FORMATS.yearMonthDay
              ) || moment(new Date()).format(DATE_TIME_FORMATS.yearMonthDay),
            ]}
            groupBy={groupBy}
            branchIds={
              filterConfig.branches
                ? filterConfig.branches
                : state.searchFilters.branchId
            }
            dataToPost={getPayload()}
          />
        );
      case ACCOUNT_SUMMARY.royalty.id:
        return (
          <FranchiseReport
            reportData={franchiseData}
            getFranchiseReportData={handleCallApi}
            setPayType = {setPayType}
            setInvoiceType = {setInvoiceType}
          />
        );
    }
  }

  function renderSummary() {
    return (
      <div className="account-summary-container">
        {(settlements?.length > 0 || !noFiltersApplied()) && (
          <>
            {renderFilters()}
            {renderSelectedSummaryType()}
          </>
        )}
        {settlements?.length === 0 && noFiltersApplied() && <ZeroScreen />}
      </div>
    );
  }
  return !state.viewSettlement ? renderSummary() : <></>;
};
export default AccountSummary;
